import React, { Component } from "react";
import { View, Text, Image, TouchableOpacity, ScrollView } from "react-native";
import { APP_COLOURS } from "../../APP_VARS";
import Fade from "react-reveal/Fade";
import moment from "moment";
import PieChart from "./PieChart";

function randomRange(n, min, max) {
	var values = [],
		i = max;
	while (i >= min) values.push(i--);
	var results = [];
	var maxIndex = max;
	for (i = 1; i <= n; i++) {
		maxIndex--;
		var index = Math.floor(maxIndex * Math.random());
		results.push(values[index]);
		values[index] = values[maxIndex];
	}
	return results.filter((d) => typeof d !== "undefined");
}

function newRandomNumber(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

function currencyFormat(num) {
	num = parseFloat(num);
	return "R " + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

export default class BASalesComm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hover: "",
			data: [
				{
					title: "Target",
					percentage: 0.8,
					percentageStr: `${currencyFormat(this.props.targetAmount)}`,
					score: newRandomNumber(5, 10),
				},
				{
					title: "Actual sales",
					percentage: 0.8,
					percentageStr: `${currencyFormat(this.props.actualSales)}`,
					score: newRandomNumber(5, 10),
				},
				{
					title: "Average Rand Sale",
					percentage: 0.65,
					percentageStr: `${currencyFormat(
						this.props.averageArs > 0 ? this.props.averageArs : 0,
					)}`,
					score: newRandomNumber(6, 10),
				},
				{
					title: "Average Items per transaction",
					percentage: 0.88,
					percentageStr: `${
						this.props.averageItp > 0
							? this.props.averageItp.toFixed(2)
							: 0
					}`,
					score: newRandomNumber(4, 10),
				},
				{
					title: "Total units sold",
					percentage: 0.88,
					percentageStr: `${this.props.totalUnitsSold.toFixed(0)}`,
					score: newRandomNumber(5, 10),
				},
			],
		};
	}

	render() {
		let barWidth = 200;
		let overallScore = 0;
		return (
			<Fade>
				<View
					style={{
						margin: 20,
						// borderBottomColor: APP_COLOURS.TRANSHALO,
						// borderBottomWidth: 0.5,
						paddingBottom: 20,
						marginTop: 40,
						width: "100%",
					}}>
					<View style={{}}>
						<View
							style={{
								flex: 1,
								marginBottom: 10,
								justifyContent: "center",
								alignItems: "center",
							}}>
							<View
								style={{
									width: "100%",
									justifyContent: "space-between",
									flexDirection: "row",
									paddingBottom: 10,
									borderBottomColor: APP_COLOURS.TRANSHALO,
									borderBottomWidth: 0.5,
									alignItems: "flex-end",
									// marginBottom: 10,
								}}>
								<View
									style={{
										position: "absolute",
										left: -12,
										top: -15,
									}}>
									<Text
										style={{
											fontSize: 13,
											color: APP_COLOURS.WHITE,
											fontWeight: "300",
											fontFamily: "Avenir",
										}}>
										SALES
										<Text
											style={{
												fontWeight: "900",
											}}>
											TRAQ
										</Text>
									</Text>
								</View>
								<Text
									style={{
										fontFamily: "Avenir",
										fontSize: 25,
										fontWeight: "100",
										color: APP_COLOURS.WHITE,
										marginBottom: 10,
									}}>
									Sales performance
								</Text>
							</View>
							<View
								style={{
									height: 300,
									width: 250,
									// backgroundColor: APP_COLOURS.BG3,
									justifyContent: "center",
									overflow: "hidden",
									alignItems: "center",
								}}>
								<PieChart
									percentage={this.props.percToTarget}
									color={APP_COLOURS.ORANGE}
								/>
							</View>
						</View>
						<View
							style={{
								flex: 1,
							}}>
							<View
								onMouseEnter={() =>
									this.setState({
										hover: "",
									})
								}
								style={{
									width: "100%",
									justifyContent: "space-between",
									flexDirection: "row",
									paddingBottom: 10,
									borderBottomColor: APP_COLOURS.TRANSHALO,
									borderBottomWidth: 0.5,
									alignItems: "flex-end",
									marginBottom: 10,
								}}>
								<View
									style={{
										position: "absolute",
										left: -12,
										top: -15,
									}}>
									<Text
										style={{
											fontSize: 13,
											color: APP_COLOURS.WHITE,
											fontWeight: "300",
											fontFamily: "Avenir",
										}}>
										SALES
										<Text
											style={{
												fontWeight: "900",
											}}>
											TRAQ
										</Text>
									</Text>
								</View>
								<Text
									style={{
										fontFamily: "Avenir",
										fontSize: 25,
										fontWeight: "100",
										color: APP_COLOURS.WHITE,
										marginBottom: 10,
									}}>
									Sales performance
								</Text>
							</View>
							<View
								style={{
									flexDirection: "row",
									alignItems: "center",
								}}>
								<View>
									{this.state.data.map((dd) => {
										overallScore =
											overallScore + parseFloat(dd.score);
										return (
											<View
												onMouseEnter={() =>
													this.setState({
														hover: dd.title,
														dataHistory:
															dd.dataHistory,
													})
												}
												style={{
													flexDirection: "row",
													marginBottom: 10,
													alignItems: "center",
													backgroundColor:
														this.state.hover ===
														dd.title
															? APP_COLOURS.TRANSHALO
															: "transparent",
												}}>
												<View
													style={{
														width: 200,
													}}>
													<Text
														style={{
															fontFamily:
																"Avenir",
															fontSize: 16,
															fontWeight: "200",
															color: APP_COLOURS.WHITE,
														}}>
														{dd.title}
													</Text>
												</View>
												<Text
													style={{
														fontFamily: "Avenir",
														fontSize: 20,
														fontWeight: "700",
														color: APP_COLOURS.WHITE,
														marginLeft: 5,
													}}>
													{dd.percentageStr}
												</Text>
											</View>
										);
									})}
								</View>
							</View>
						</View>
					</View>

					<View
						style={{
							alignItems: "flex-end",
							marginTop: 30,
							position: "absolute",
							top: -50,
							right: 0,
						}}>
						<Text
							style={{
								fontStyle: "italic",
								fontFamily: "Avenir",
								fontSize: 10,
								fontWeight: "100",
								color: APP_COLOURS.WHITE,
							}}>
							Sales performance report
						</Text>
						<Text
							style={{
								fontStyle: "italic",
								fontFamily: "Avenir",
								fontSize: 10,
								fontWeight: "100",
								color: APP_COLOURS.WHITE,
							}}>
							{moment().format("MMMM, YYYY")}
						</Text>
					</View>
				</View>
			</Fade>
		);
	}
}
